export default __webpack_public_path__ + "static/media/educampuslogo.8bb88e72.png";